import React from "react"

const ErrorMessage = ({ translations }) => {
  return (
    <div className="flex px-4">
      <div className="flex flex-col items-center justify-center gap-2 p-6 max-w-[650px] mx-auto">
        <h4 className="ipxon-magenta-text-gradient text-sm text-center w-full">{translations["PresenceServicesErrorMssgTitle"]}</h4>
        <p className="text-sm text-center text-gray-600">{translations["PresenceServicesErrorMssg"]}</p>
      </div>
    </div>
  )
}

export default ErrorMessage
